<template>
  <nuttrema-layout-form-standard :edit="true" theme="west-top" :saveError="InvitationDetails.saveError">
    <template slot="center">
      <el-form
         label-position="top"
        :ref="formRef"
        :model="formData">

        <section>
          <p class="section-title">{{ $t('label.details') }}</p>
          <div class="section-items">
            <el-form-item  :label="$t('label.name')">
              <el-input :value="_get(InvitationDetails, 'data.name')" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item  :label="$t('label.email')">
              <el-input :value="_get(InvitationDetails, 'data.email')" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item  :label="$t('label.invitation_type')">
              <el-input :value="$t(`label.${_get(InvitationDetails, 'data.invitation_type')}`)" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item  :label="$t('label.status')">
              <el-input :value="$t(`label.${_get(InvitationDetails, 'data.status')}`)" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item  :label="$t('label.resend_count')">
              <el-input :value="_get(InvitationDetails, 'data.resend_count')" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item  :label="$t('label.updated_at')">
              <el-input :value="_get(InvitationDetails, 'data.updated_at') | moment('LLL')" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item :label="$t('label.custom_message')" prop="custom_message">
              <el-input
                 type="textarea"
                :disabled="true"
                :value="_get(InvitationDetails, 'data.message')"
                :autosize="{ minRows: 2, maxRows: 5 }">
              </el-input>
            </el-form-item>
          </div>
        </section>

      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">
        <div class="footer-row__column">
          <el-button type="primary" :plain="true" size="small" :loading="action === 'resend' && isSaving" @click="handleResendInvitation">{{ $t('label.resend') }}</el-button>
          <el-button type="warning" :plain="true" size="small" :loading="action === 'cancel' && isSaving" @click="handleCancelInvitation">{{ $t('label.cancel_invite') }}</el-button>
          <el-button type="text" size="small" @click="cancelChanges">{{ $t('label.done') }}</el-button>

        </div>
        <div class="footer-row__column">
          <popover-question-alert
             buttonTitle="label.delete"
             buttonType="danger"
             popoverWidth="280"
             popoverTitle="label.delete"
             popoverText="label.delete_sure"
             popoverPlacement="top-end"
             buttonSize="small"
            :loading="isDeletion"
            :popoverShouldShow="true"
            @confirmed="handleDelete">
          </popover-question-alert>
        </div>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';
import FormStandardBehavior from 'src/components/mixins/form-standard-behavior';

import PopoverQuestionAlert from 'components/ui/alert/nuttrema-popover-question-alert';

export default {
  name: 'form-invite-details',
  mixins: [
    FormStandardBehavior,
  ],
  props: {
    InvitationDetails: {
      required: true,
      default: null,
    },
  },
  components: {
    PopoverQuestionAlert,
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      action: null,
    };
  },
  methods: {
    handleResendInvitation() {
      this.action = 'resend';
      this.$emit('resendInvite');
    },
    handleCancelInvitation() {
      this.action = 'cancel';
      this.$emit('cancelInvite');
    },
  },
  created() {
    this.formRef = 'form-invite-details';
    this.stateData = this.InvitationDetails;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/invitations/details/form-invite-details.vue